import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSleep: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSleep"><Path fillRule="evenodd" clipRule="evenodd" d="M11 2H16.5V4.01916L13.7179 7H16.5V9H11V6.98084L13.7821 4H11V2ZM3 8H9V10.1302L5.56018 14H9V16H3V13.8698L6.43982 10H3V8ZM12 12H20V13.9472L14.7038 20H20V22H12V20.0528L17.2962 14H12V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSleep;
